import React, { Component } from 'react';
import asyncComponent from '../../helpers/AsyncFunc';
import Route from '../../components/utility/customRoute';

const routes = [
	{
		path: '',
		component: asyncComponent(() => import('../Dashboard')),
	},
	{
		path: 'confirm/:hash',
		component: asyncComponent(() => import('../Confirm'),)
	},
	{
		path: 'confirm-account/:hash',
		component: asyncComponent(() => import('../Confirm'),)
	},
	{
		path: 'blank-page',
		component: asyncComponent(() => import('../blankPage')),
	},
	{
		path: 'profile',
		component: asyncComponent(() => import('../Profile')),
	},
	{
		path: 'myproperties',
		component: asyncComponent(() => import('../Properties2'))
	},
	{
		path: 'addproperty',
		component: asyncComponent(() => import('../Properties2/create'))
	},
	{
		path: 'editproperty/:hash/:step',
		component: asyncComponent(() => import('../Properties2/edit'))
	},
	{
		path: 'advertiseproperty/:hash/viewing-preferences',
		component: asyncComponent(() => import('../PropertiesAdvertise/viewingPreferences'))
	},
	{
		path: 'advertiseproperty/:hash/:slotHash/payment',
		exact: true,
		component: asyncComponent(() => import('../PropertiesAdvertise/advertiseProperty'))
	},
	{
		path: 'advertiseproperty/:hash/payment',
		exact: true,
		component: asyncComponent(() => import('../PropertiesAdvertise/advertiseProperty'))
	},
	{
		path: 'propertyadded/:hash',
		component: asyncComponent(() => import('../Properties2/propertyAdded'))
	},
	{
		path: 'property-listings/:hash',
		component: asyncComponent(() => import('../PropertyListings'))
	},
	{
		path: 'property-listings',
		component: asyncComponent(() => import('../PropertyListings'))
	},
	{
		path: 'findtenants/:hash',
		component: asyncComponent(() => import('../Properties2/propertyAdded'))
	},
	{
		path: 'tenantreferencing',
		component: asyncComponent(() => import('../Tenants/tenantReferencing')),
	},
	{
		path: 'tenantreferencing/:hash',
		component: asyncComponent(() => import('../Tenants/tenantReference')),
	},
	{
		path: 'outstandingreferences',
		component: asyncComponent(() => import('../Tenants/outstandingReferenceRequests')),
	},
	{
		path: 'outstandingreferences/:hash/:type',
		component: asyncComponent(() => import('../Tenants/referenceTenant')),
	},
	{
		path: 'currenttenants',
		component: asyncComponent(() => import('../Tenants/currentTenants')),
	},
	{
		path: 'issues',
		exact: true,
		component: asyncComponent(() => import('../Issues')),
	},
	{
		path: 'issues/:hash',
		exact: true,
		component: asyncComponent(() => import('../Issues/issueDetails')),
	},
	{
		path: 'tenancy-agreements/:propertyHash',
		component: asyncComponent(() => import('../PropertiesTenancyAgreements'))
	},
	{
		path: 'tenancy-agreements/view/:agreementHash',
		component: asyncComponent(() => import('../PropertiesTenancyAgreements/view'))
	},
	{
		path: 'tenancy-agreements/create/:propertyHash',
		component: asyncComponent(() => import('../PropertiesTenancyAgreements/create'))
	},
	{
		path: 'tenancy-agreements/progress/:agreementHash/:step',
		component: asyncComponent(() => import('../PropertiesTenancyAgreements/edit'))
	},
	{
		path: 'rentverifications',
		component: asyncComponent(() => import('../Tenants/outstandingRentVerifications')),
	},
	{
		path: 'rentverifications/verifyrentpayment/:vhash',
		component: asyncComponent(() => import('../Tenants/verifyRentPayment')),
	},
	{
		path: 'viewings/:bookingHash',
		component: asyncComponent(() => import('../Calendar')),
	},
	{
		path: 'viewings',
		component: asyncComponent(() => import('../Calendar')),
	},
	{
		path: 'messages/:bucket/:threadid/:page',
		component: asyncComponent(() => import('../Mail'))
	},
	{
		path: 'messages/:bucket/:threadid',
		exact: true,
		component: asyncComponent(() => import('../Mail'))
	},
	{
		path: 'messages/:bucket',
		exact: true,
		component: asyncComponent(() => import('../Mail'))
	},
	{
		path: 'messages',
		exact: true,
		component: asyncComponent(() => import('../Mail'))
	},
	{
		path: 'myaccount',
		exact: true,
		component: asyncComponent(() => import('../Profile/myAccount'))
	},
	{
		path: 'premium/subscribe',
		component: asyncComponent(() => import('../PropertiesSubscribe')),
	},
	{
		path: 'premium/subscribe/:hash',
		component: asyncComponent(() => import('../PropertiesSubscribe')),
	},
	{
		path: 'premium',
		exact: true,
		component: asyncComponent(() => import('../PropertyManager'))
	},
	{
		path: 'uppy',
		component: asyncComponent(() => import('../AdvancedModules/Uppy')),
	},
	{
		path: 'cancel-subscription/:propertyHash',
		component: asyncComponent(() => import('../CancelSubscriptions')),
	},
	{
		path: 'property/:hash',
		component: asyncComponent(() => import('../PropertyDashboard')),
	}
];

class AppRouter extends Component {
	render() {
		const { url, style, ...outerProps } = this.props;
		return (
			<div style={style}>
				{routes.map(singleRoute => {
					const { path, exact, ...otherProps } = singleRoute;
					return (
						<Route
							exact={exact === false ? false : true}
							key={singleRoute.path}
							path={`${url}/${singleRoute.path}`}
							{...otherProps}
							{...outerProps}
						/>
					);
				})}
			</div>
		);
	}
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/containers/App/appRouter.js